import React from "react";
import PropTypes from "prop-types";
import ExternalLayout from "../../../customComponents/ExternalLayout/ExternalLayout";
import RenderPage from "../../../customComponents/RenderPage/RenderPage";
import Strip from "../../../customComponents/Strip/Strip";
import { useWindowSize } from "@react-hook/window-size";
import SEOComponent from "../../../customComponents/SEO/SEOComponent";
import Registers from "../Banner/RegisterButtons";

const Registration1 = (props) => {
    const [width] = useWindowSize();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return(
        <ExternalLayout>
      <RenderPage
        id="tst-Hack4TTS"
        className={`render px-0 ${
          props.isClassName ? "render-page " : "min-height-auto"
        }`}
        containerType="container-fluid"
      >
       <SEOComponent
          title="Voice Tech for All"
          keywords="SYnthesizing SPeech in INdian languages"
          description="Speech recognition in agriculture and finance for the poor is an initiative predominantly to create resources and make them available as a digital public good"
          siteUrl="/Hack4TTS" />
           <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '2800px',
            width: '100vw',
            padding: '20px', // Adds some spacing
          }}
        >
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLScJU552Ul1_oO4k96LQ0RmnQyQhuSvw7BopfQUkUiO8iIxsrw/viewform?embedded=true" 
          width="100%"
          height="100%"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
          style={{ maxWidth: '800px' }} // The iframe will not exceed 800px in width
        >
          Loading…
        </iframe>





        </div>
        <Strip
          id="tst-Hack4TTS"
          className="strip strip-no-padding"
          containerType="container"
        >
            

</Strip>
</RenderPage>
</ExternalLayout>
);
};
Registration1.defaultProps = {
  isClassName: true,
};
Registration1.propTypes = {
  isClassName: PropTypes.bool,
};
export default Registration1;